import { useCallback } from 'react';
import { TemplateType_Slug } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { usePreference } from '@frontend/user-preferences';
import { STATIC_TEMPLATE_ID } from '../constants';

type TemplateSortingPreference = 'most-recent' | 'a-z' | 'z-a';

export const useUpdateTemplateLastTimestamp = () => {
  const [lastTemplateUseTimestamps = {}, setLastTemplateUseTimestamps] = usePreference('TemplateLastUsedTimestamps');

  const [userTemplateSortingPreferences = {}, setUserTemplateSortingPreferences] =
    usePreference('TemplateSortingPreferences');

  const updateTemplateLastUseTimestamp = useCallback(
    ({
      templateId,
      templateType,
      timestamp,
    }: {
      templateId: string;
      templateType: TemplateType_Slug;
      timestamp?: string | Date;
    }) => {
      if (!templateId || templateId.includes(STATIC_TEMPLATE_ID)) return;

      const nextTimestamp =
        typeof timestamp === 'string' ? timestamp : timestamp?.toISOString() ?? new Date().toISOString();

      setLastTemplateUseTimestamps({
        ...lastTemplateUseTimestamps,
        [templateId]: {
          templateType,
          timestamp: nextTimestamp,
        },
      });
    },
    [lastTemplateUseTimestamps, setLastTemplateUseTimestamps]
  );

  const setTemplateSortingPreference = useCallback(
    ({ userId, newPreference }: { userId: string; newPreference: TemplateSortingPreference }) => {
      if (!userId) return;

      setUserTemplateSortingPreferences({
        ...userTemplateSortingPreferences,
        [userId]: newPreference,
      });
    },
    [userTemplateSortingPreferences, setUserTemplateSortingPreferences]
  );

  return {
    lastTemplateUseTimestamps,
    updateTemplateLastUseTimestamp,
    userTemplateSortingPreferences,
    setTemplateSortingPreference,
  };
};
